
import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
/**
 * Service AuthService
 */
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClientService } from './httpClient.service';
import { HttpParams } from "@angular/common/http";

import * as Rx from 'rxjs';


@Injectable()
export class ProfileService {
  private _baseURL = "/api/profiles/";

  constructor(private _http: HttpClientService) {
  }

  getAll(userFilter, pidFilter) {

    //noinspection TypeScriptValidateTypes
    let url = this._baseURL;
    let params = new HttpParams();
    if (userFilter && userFilter != -1) {
      params = params.set('role', userFilter);
    }
    if (pidFilter && pidFilter != -1) {
      params = params.set('pidState', pidFilter);
    }
    if (params.keys().length) {
      url += '?' + params.toString();
    }
    console.log('getall', url, userFilter, pidFilter);
    return this._http.get(url);//.subscribe(res => res, err => this._handleError(err));
  }

  me(nbPIDTotal : Boolean = false) {
    let url = this._baseURL + "me";

    //noinspection TypeScriptValidateTypes
    return this._http.get(url + '?nbPIDTotal=' + nbPIDTotal);//.subscribe(res => res, err => this._handleError(err));
  }

  delete(id) {
    let url = this._baseURL + id;

    //noinspection TypeScriptValidateTypes
    return this._http.delete(url);/*.subscribe(
      res => res, err => this._handleError(err));*/
  }

  update(me) {
    let url = this._baseURL + "me";
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify(me), headers)/*.subscribe(res => res,
      err => this._handleError(err))*/;
  }


  uploadImg(url, file) {
    return Rx.Observable.create(obs => {
      var xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.onload = function () {
        if (xhr.status === 200) {
          obs.next("Success");
        } else {
          obs.error("Could not upload file.");
        }
      };
      xhr.onerror = function () {
        obs.error("Could not upload file.");
      };
      xhr.send(file);
    });
  }


  updatePersonalInformations(token, profile, newPassword) {
    let url = this._baseURL + "update/" + profile._id + "/" + token;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    //noinspection TypeScriptValidateTypes
    return this._http.put(url, JSON.stringify({ profile: profile, newPassword: newPassword }), headers)/*.subscribe(res => res,
      err => this._handleError(err))*/;
  }

  private _handleError(error) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return observableThrowError(error['message'] || error['_body'] || 'Server error');
  }
}
